import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AlertMessageService } from '@bundle/component/alert-message/alert-message.service';

@Component({
  selector: 'app-ms24-reject-reason',
  templateUrl: './ms24-reject-reason.component.html',
  styleUrls: ['./ms24-reject-reason.component.css']
})
export class Ms24RejectReasonComponent implements OnInit {
  remark: string = "";

  constructor(
    private dialogRef: MatDialogRef<Ms24RejectReasonComponent>,
    private alertMessage: AlertMessageService
  ) { }

  ngOnInit() {
  }

  saveReason() {
    if (this.remark == undefined || this.remark == null || this.remark == "" || this.remark.length == 0) {
      this.alertMessage.open({
        message: "กรุณาระบุเหตุผลที่ไม่อนุมัติเอกสาร",
        title: ""
      });

      return;
    }

    this.dialogRef.close(this.remark);
  }
}
